import { useGraphAPI } from '@newfront-insurance/ms-graph-auth';
import type { ReactNode } from 'react';

import { MSGraphProvider } from '../chat-v2/contexts/ms-graph-context';

interface MSGraphRootProps {
  children: ReactNode;
  /** When true, MS Graph auth is active. When false, context is null and MSAL never initializes. */
  enabled?: boolean;
}

/**
 * Root primitive for MS Graph authentication.
 * Owns the useGraphAPI() call and provides auth state to all descendants via context.
 *
 * @example
 * // Feature-flag controlled (Navigator Nova)
 * <MSGraphRoot enabled={msGraphEnabled}>...</MSGraphRoot>
 */
export function MSGraphRoot({ children, enabled = true }: MSGraphRootProps) {
  if (!enabled) {
    return <MSGraphProvider value={null}>{children}</MSGraphProvider>;
  }
  return <MSGraphRootInternal>{children}</MSGraphRootInternal>;
}

/** Calls useGraphAPI — only rendered when enabled=true. */
function MSGraphRootInternal({ children }: { children: ReactNode }) {
  const msGraphAuth = useGraphAPI();
  return <MSGraphProvider value={msGraphAuth}>{children}</MSGraphProvider>;
}
